// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_2EoYm","title":"index_title_3eyvI","time":"index_time_36nIQ","content":"index_content_39Ip4","tabs":"index_tabs_3i_k0"};